export default {
  playbackItem: undefined,
  playbackItems: [],
};
